import * as React from 'react';
import {Link as RoutedLink} from 'react-router-dom';

import {EmptyStateLarge} from 'shells/empty-states/empty-state-large';
import {Illustration} from 'shells/illustrations/illustration';
import {Link} from 'shells/link/link';

type Props = {
    locationSearch: string;
};

export function EmptyState(props: Props) {
    return (
        <EmptyStateLarge
            title='Create a form'
            subtitle='Design a beautiful form to collect new contacts and leads from your website'
            detailTextBullets={[
                'Make your form in Nutshell and embed it on your website with an easy snippet',
                'Seamlessly bring new contact information and leads into Nutshell',
            ]}
            cta={
                <Link
                    size='big'
                    variant='button-primary'
                    // @ts-expect-error
                    as={RoutedLink}
                    to={{
                        // GREP #/create/forms
                        hash: '#/create/forms',
                        search: props.locationSearch,
                        state: {modal: true},
                    }}
                    replace={true}
                >
                    Create new form
                </Link>
            }
            icon={
                <div style={{width: 140}}>
                    <Illustration src='cactus-empty-state' width='100%' height='100%' />
                </div>
            }
        />
    );
}
